import {ErrorSerializerClass, coalesce, safeGet} from '@lacele/utils'
import defaultJsonTypeSerializers from './jsonTypeSerializers'

export class FetchErrorSerializer extends ErrorSerializerClass {

    constructor() {
        super()
        this.jsonTypeSerializers = {}
    }

    registerJsonTypes(jsonTypeSerializers) {
        Object.assign(this.jsonTypeSerializers, jsonTypeSerializers)
    }

    customSerialize(context, error) {
        const {
            response
        } = error
        const contentType = response && response.headers && response.headers.get('content-type')
        if (contentType) {
            if (contentType.includes('application/json')) {
                return response.json().then((json) => this.serializeJson(context, error, json))
            }
            if (contentType.includes('application/errorDescriptor+json')) {
                return response.json().then((json) => (
                    this.serializeJson(context, error, json, 'application/errorDescriptor+json')
                ))
            }
            if (contentType.includes('text/html')) {
                return response.text().then((text) => this.serializeHtml(context, error, text))
            }
            return response.text().then((text) => this.serializeText(context, error, text))
        }
        return undefined
    }

    serializeText(context, error, text) {
        return this.makeErrorData(context, error, text)
    }

    serializeJson(context, error, json, defaultJsonType) {
        const jsonMessage = this.getJsonMessage(context, error, json)
        const errorData = this.makeErrorData(context, error, jsonMessage)
        const type = json.type || json.exception || defaultJsonType
        const jsonTypeSerializer = this.jsonTypeSerializers[type]
        if (jsonTypeSerializer) {
            const errorDataNew = jsonTypeSerializer.serialize(context, errorData, json)
            return errorDataNew || errorData
        }
        return errorData
    }

    serializeHtml(context, error, html) {
        const errorData = {
            type: 'Error',
            name: error.name,
            message: 'ERROR_CODE_HTML_MESSAGE',
            messages: [error.message],
            html
        }
        return errorData
    }

    getJsonMessage(context, error, json) {
        if (typeof json.type === 'string') {
            if (json.type.endsWith('Exception')) {
                return coalesce(
                    safeGet(json, 'meta', 'mostSpecificCause', 'message'),
                    json.message
                )
            }
        }
        return json.message
    }

    makeErrorData(context, error, message) {
        const errorData = super.makeErrorData(context, error)
        // Move the original message to the list, it could be too technical.
        errorData.messages.unshift(errorData.message)
        // Replace the original message by the new one
        errorData.message = message
        return errorData
    }
}

// Create singleton
const fetchErrorSerializer = new FetchErrorSerializer()

// Register default json type serializers
fetchErrorSerializer.registerJsonTypes(defaultJsonTypeSerializers)

export default fetchErrorSerializer
 